export default {"src":"/_next/static/media/artifactory.f84d4d6f.svg","height":20,"width":19};